module.exports = __webpack_public_path__ + "img/emoji-frown-fill.29e3e767.svg";